import { Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';

/**
 * 공개 폴더 안의 퀴즈를 숨기려 할 때 뜨는 안내.
 *
 * 공개 폴더에는 공개 퀴즈만 담긴다. 숨기기 토글을 미리 막고, 갈 수 있는 두 곳(비공개 폴더 · 내 퀴즈)을
 * 여기서 고르게 한다. 비공개 전환 자체는 사용자가 다시 누른다.
 */
export const PublicFolderMoveNotice = ({
  onSelectFolder,
  onMoveToMyQuiz,
  isMoving
}: {
  onSelectFolder: () => void;
  onMoveToMyQuiz: () => void;
  isMoving: boolean;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  return <div className="flex w-full flex-col items-stretch gap-xs rounded-sm bg-neutral p-sm mobile-lg:flex-row mobile-lg:items-center" data-sentry-component="PublicFolderMoveNotice" data-sentry-source-file="PublicFolderMoveNotice.tsx">
      <p className="min-w-0 flex-1 text-body-sm-medium text-neutral">
        {t('build:build.publicFolderMove.notice')}
      </p>
      <div className="flex shrink-0 gap-xs">
        <Button type="button" size="xs" variant="outlined" intent="neutral" disabled={isMoving} onClick={onSelectFolder} className="flex-1 whitespace-nowrap mobile-lg:flex-none" data-sentry-element="Button" data-sentry-source-file="PublicFolderMoveNotice.tsx">
          {t('common:folderSave.modal.title')}
        </Button>
        <Button type="button" size="xs" variant="outlined" intent="alternative" disabled={isMoving} onClick={onMoveToMyQuiz} className="flex-1 whitespace-nowrap mobile-lg:flex-none" data-sentry-element="Button" data-sentry-source-file="PublicFolderMoveNotice.tsx">
          {t('build:build.publicFolderMove.toMyQuiz')}
        </Button>
      </div>
    </div>;
};